import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? ""; // empty = same-origin (self-hosted / same-domain deploys)
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

const TZ_KEY = "hc_tz";
export const detectedTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
/** The zone the app runs on: the user's chosen home zone when set, else the device zone. */
export const localTimezone = () => localStorage.getItem(TZ_KEY) || detectedTimezone();
export const setTimezoneOverride = (tz) => { if (tz) localStorage.setItem(TZ_KEY, tz); else localStorage.removeItem(TZ_KEY); };
api.interceptors.request.use((config) => {
  config.headers["X-Timezone"] = localTimezone();
  return config;
});

let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const { response, config } = err;
    if (response?.status === 401 && config && !config._retried && !/\/auth\/(login|register|refresh|logout)/.test(config.url)) {
      config._retried = true;
      try {
        refreshing = refreshing || axios.post(`${API}/auth/refresh`, {}, { withCredentials: true }).finally(() => { refreshing = null; });
        await refreshing;
        return api(config);
      } catch (_) {
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    if (response?.status === 402) {
      import("sonner").then(({ toast }) =>
        toast.error(response.data?.detail || "Subscribe to keep logging.", {
          id: "billing-402",
          duration: 8000,
          action: { label: "See plans", onClick: () => { window.location.href = "/billing"; } },
        })
      );
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
